import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// eslint-disable-next-line import/no-cycle
import {
  BarChart,
  BubbleChart,
  DoughnutChart,
  LineChart,
  TimeLineChart
} from 'ui/components';

// eslint-disable-next-line import/no-cycle
import MainFont from 'ui/typography/mainFont';

import { ChartWrapper, VerticalLabel, WrapperChart } from './style';

const ChartCard = ({
  title,
  type,
  labels,
  widgetID,
  getWidgetData,
  action,
  style,
  config,
  data,
  item,
  verticalTitle,
  isBiggerChart
}) => {
  const refChart = useRef();
  const [width, setWidth] = useState(null);

  useEffect(() => {
    if (action) {
      //adapt to redux data provided
      getWidgetData(widgetID, action);
    }
  }, [widgetID, action, getWidgetData]);

  useEffect(() => {
    if (refChart.current) {
      setWidth(refChart.current.offsetWidth);
    }
  }, [refChart]);

  useLayoutEffect(() => {
    function updateSize() {
      setWidth(refChart.current.offsetWidth);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, [title]);

  const renderChart = () => {
    switch (type) {
      case ChartCard.TYPE.LINE:
        return <LineChart labels={labels} dataset={data} lineStyle={style} />;
      case ChartCard.TYPE.TIMELINE:
        return <TimeLineChart timeLineDataset={data} timeLineStyle={style} />;

      case ChartCard.TYPE.BAR:
        return (
          <BarChart
            labels={labels}
            dataset={data}
            widgetID={widgetID}
            barStyle={style}
            config={config}
          />
        );

      case ChartCard.TYPE.DOUGHNUT:
        return (
          <DoughnutChart
            labels={labels}
            dataset={data}
            doughnutStyle={style}
            title={title}
            item={item}
          />
        );

      case ChartCard.TYPE.BUBBLE:
        return <BubbleChart data={data} bubbleChartStyle={style} />;

      default:
        return <></>;
    }
  };

  return (
    <WrapperChart ref={refChart} width={width}>
      <ChartWrapper>{renderChart()}</ChartWrapper>
      {verticalTitle && (
        <VerticalLabel isBiggerChart={isBiggerChart}>
          <MainFont type="labelChart">{verticalTitle}</MainFont>
        </VerticalLabel>
      )}
    </WrapperChart>
  );
};

ChartCard.TYPE = {
  LINE: 'line',
  BAR: 'bar',
  DOUGHNUT: 'doughnutChart',
  BUBBLE: 'bubbleChart',
  TIMELINE: 'timeLineChart'
};

ChartCard.propTypes = {
  title: PropTypes.string,
  data: PropTypes.object,
  type: PropTypes.oneOf([
    ChartCard.TYPE.LINE,
    ChartCard.TYPE.BAR,
    ChartCard.TYPE.DOUGHNUT,
    ChartCard.TYPE.BUBBLE,
    ChartCard.TYPE.TIMELINE
  ]),
  labels: PropTypes.array,
  widgetID: PropTypes.string,
  getWidgetData: PropTypes.func,
  action: PropTypes.object,
  style: PropTypes.object,
  config: PropTypes.object,
  item: PropTypes.string,
  verticalTitle: PropTypes.string,
  isBiggerChart: PropTypes.bool
};

export default connect(
  state => ({ widgets: state.widgets }),
  dispatch => ({
    getWidgetData: (widgetID, action) =>
      dispatch({
        type: action._REQUEST,
        widgetID
      })
  })
)(ChartCard);
